import { useAuthStore } from '@/state/store/auth';
import { useNavigate } from 'react-router-dom';
import { UsersAdminClient } from '../components/users-admin-client';

export default function UsersAdminPage() {
  const { userId, platformRole } = useAuthStore();
  const router = useNavigate();
  if (!userId) {
    router('/login');
  }

  const role = platformRole;

  // Only admins can access user management
  if (role !== 'sys_admin') {
    router('/admin/templates');
  }

  return <UsersAdminClient />;
}
